import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { SliderView } from '@estee/elc-slider';
import BaseLink from '~components/BaseLink';

const smartphoneBreakpoint = 480;
const smallSmartphoneBreakpoint = 380;
export const ShowcaseWrapper = styled.section`
    align-self: flex-end;
    display: grid;
    gap: ${ContentSpacing.space4} 0;
    grid-template-columns: 1fr 0.5fr;
    grid-template-rows: 30px 1fr;
    margin: 0 0 0 ${ContentSpacing.space16};
    overflow: hidden;
    padding: ${ContentSpacing.space10} 0 0;
    width: 100%;
`;
export const ClickableShowcaseImage = styled(BaseLink)`
    align-items: center;
    display: flex;
    justify-content: left;
    margin: 0;
    overflow: hidden;
    padding: 0;
    text-decoration: none;
    transition: none;
`;
export const EditorialLink = styled(BaseLink)`
    display: inline-block;
    margin-top: ${ContentSpacing.space10};
    padding: 0;
`;
export const ShowcaseHeaderLink = styled(BaseLink)`
    display: block;
    height: fit-content;
    margin-left: auto;
    margin-right: 16px;
    padding: 0 0 3px 1px;
    width: fit-content;
`;
export const StyledSlider = styled(SliderView)`
    grid-column: 1 / span 2;
    padding: 0;
    width: 360px;
    @media only screen and (min-width: ${smallSmartphoneBreakpoint}px) {
        width: 400px;
    }

    .slick-slider {
        margin-bottom: 0;
    }

    .slick-list {
        padding-left: 0;
        .slick-track {
            margin-left: 143px;
            @media only screen and (min-width: ${smallSmartphoneBreakpoint}px) {
                margin-left: 100px;
            }
            & > * {
                margin-bottom: 0;
            }
        }
    }

    &.elc-account-showcase-copy-slider {
        width: auto;
        @media only screen and (min-width: ${smartphoneBreakpoint}px) {
            width: 400px;
        }
        .slick-slider {
            padding-right: 16px;
            width: auto;
            @media only screen and (min-width: ${smartphoneBreakpoint}px) {
                width: 400px;
            }
        }
        .slick-list {
            .slick-track {
                margin-left: 0;

                & > * {
                    margin-bottom: ${ContentSpacing.space32};
                }
            }
        }
    }

    .slick-slide {
        h3 {
            display: block;
            margin: 5px 0 0;
        }
        span {
            display: inline;
        }
        .elc-account-showcase-link {
            display: inline;
            margin-left: ${ContentSpacing.space6};
        }
    }

    .slick-next {
        height: 138px;
        margin-top: 0;
        right: -2px;
        top: 0;
        width: 145px;

        @media only screen and (min-width: ${smallSmartphoneBreakpoint}px) {
            height: 183px;
            width: 100px;
        }

        &::before {
            content: '';
        }
        .elc-icon {
            display: none;
        }
        &.slick-disabled {
            display: none;
        }
    }

    .slick-prev {
        display: none;
    }

    .elc-slider-dots-list {
        margin: 0;

        .elc-slider-dot-button {
            border-radius: 50%;
        }

        & .elc-slider-dot-button-active {
            background-color: unset;
            &::before {
                opacity: 1;
            }
        }

        .elc-slider-dot {
            float: left;
            margin-left: 0;
        }
    }

    .slick-slider a:focus,
    .slick-slider button:focus,
    .slick-next:focus,
    .slick-slide.slick-current a:focus {
        outline: rgb(0, 0, 0) thin dotted;
        transition: none;
    }
`;
